import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NotificationRoutingModule } from './notification-routing.module';
import { NotificationViewComponent } from './notification-view/notification-view.component';
import { NotificationService } from './services/notification.service';
import { MatTableModule, MatPaginatorModule, MatSortModule, MatFormFieldModule, MatDialogModule, MatInputModule, MatButtonModule } from '@angular/material';
import { SatPopoverModule } from '@ncstate/sat-popover';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [NotificationViewComponent],
  imports: [
    CommonModule,
    NotificationRoutingModule,
    CommonModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    SatPopoverModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    FormsModule
    
  ],
  providers: [NotificationService],
  exports: [
    NotificationViewComponent
 ]
  
})
export class NotificationModule { }
